<template>
  <div class="common-layout">
    <div v-if="isMobile && showMobileSidebar" class="mobile-overlay" @click="showMobileSidebar = false"></div>
    <el-container>
        <el-aside class="aside" :class="{ 'mobile-aside': isMobile, 'mobile-aside-open': showMobileSidebar }">
          <div class="logo">
          <img src="../assets/logo.png" alt="logo" class="logo-img" />
          <span class="title" v-if="!isCollapse || isMobile">无界赛程智能管理平台</span>
        </div>
          <el-menu
            :default-active="activeIndex"
            :collapse="isCollapse && !isMobile"
            class="el-menu-vertical"
            :unique-opened="true"
            :default-openeds="openeds"
            router
            @select="handleMenuSelect"
          >

            <el-sub-menu :index="value.rule" v-for="value in menuTree" :key="value.id">
              <template #title>
              <el-icon v-if="value.icon"><component :is="value.icon" /></el-icon>
              <el-icon v-else><Postcard /></el-icon>
                <span>{{value.name}}</span>
              </template>
               <el-menu-item v-for="item in value._child" :index="item.rule" :key="item.id">{{item.name}}</el-menu-item>
            </el-sub-menu>

            <el-sub-menu index="/prelim-management">
              <template #title>
                <el-icon><Postcard /></el-icon>
                <span>初赛管理</span>
              </template>
              <el-menu-item index="/schedule">设置初赛赛程表</el-menu-item>
            </el-sub-menu>
            <el-sub-menu index="/provincial-management">
              <template #title>
                <el-icon><Postcard /></el-icon>
                <span>省决赛管理</span>
              </template>
              <el-menu-item index="/provincial-schedule">设置省决赛赛程表</el-menu-item>
            </el-sub-menu>
            <el-sub-menu v-if="isAdmin" index="/final-management">
              <template #title>
                <el-icon><Postcard /></el-icon>
                <span>总决赛管理</span>
              </template>
              <el-menu-item index="/final-user-audit">总决赛用户管理</el-menu-item>
              <el-menu-item index="/final-schedule">全国总决赛赛程安排</el-menu-item>
            </el-sub-menu>
          </el-menu>
        </el-aside>

      <el-container class="main-container">
            <el-header class="header">
  <div>
  <el-icon v-if="isCollapse && !isMobile" @click="toggleSidebar"><Expand /></el-icon>
  <el-icon v-if="!isCollapse && !isMobile" @click="toggleSidebar"><Fold /></el-icon>
  <el-icon v-if="isMobile" @click="toggleSidebar"><Expand /></el-icon>
  </div>
        <div class="user-info">
          <el-dropdown trigger="hover">
            <span class="dropdown-trigger">
              <el-avatar :size="32" src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png" />
              <span class="username">{{ username }}</span>
            </span>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="handleLogout">退出登录</el-dropdown-item>
                <el-dropdown-item @click="handleUpdatePassword">修改密码</el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </el-header>
        <el-main class="main">
          <router-view />
        </el-main>
        <el-footer class="footer">
          <a href="https://beian.miit.gov.cn/" target="_blank">沪ICP备2026005021号-1</a>
        </el-footer>
      </el-container>
    </el-container>

    <!-- 修改密码弹窗 -->
    <el-dialog v-model="passwordDialogVisible" title="修改密码" width="400px">
      <el-form ref="passwordFormRef" :model="passwordForm" :rules="passwordRules" label-width="100px">
        <el-form-item label="新密码" prop="password">
          <el-input v-model="passwordForm.password" type="password" show-password placeholder="请输入新密码" />
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input v-model="passwordForm.confirmPassword" type="password" show-password placeholder="请再次输入新密码" />
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="passwordDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="submitPassword">确认</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
  import { Expand, Fold, DataBoard, Postcard, Message } from '@element-plus/icons-vue'
  import { ref, reactive, watch,onMounted, onUnmounted } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { getMenuList, updateUserPassword } from "@/services/api";
  import { setToken } from '@/services/http'
  import { ElMessage } from 'element-plus'

  const isCollapse = ref(false)
  const isMobile = ref(false)
  const showMobileSidebar = ref(false)
  const route = useRoute()
  const router = useRouter()
  const activeIndex = ref(route.path)
  const openeds = ref([])
  const menuTree = ref([])
  const username = ref('')
  const isAdmin = ref(false)
  
  const checkMobile = () => {
    const mobile = window.innerWidth < 768
    if (mobile !== isMobile.value) {
      isMobile.value = mobile
      if (mobile) {
        isCollapse.value = false // 移动端不使用折叠模式，而是显示/隐藏
        showMobileSidebar.value = false // 默认隐藏
      }
    }
  }

  const toggleSidebar = () => {
    if (isMobile.value) {
      showMobileSidebar.value = !showMobileSidebar.value
    } else {
      isCollapse.value = !isCollapse.value
    }
  }

  const handleMenuSelect = () => {
    if (isMobile.value) {
      showMobileSidebar.value = false
    }
  }

  // 修改密码相关
  const passwordDialogVisible = ref(false)
  const passwordFormRef = ref()
  const passwordForm = reactive({
    password: '',
    confirmPassword: ''
  })
  const validateConfirm = (rule, value, callback) => {
    if (!value) {
      callback(new Error('请再次输入新密码'))
      return
    }
    if (value !== passwordForm.password) {
      callback(new Error('两次输入的新密码不一致'))
      return
    }
    callback()
  }
  const passwordRules = {
    password: [{ required: true, message: '请输入新密码', trigger: 'blur' }],
    confirmPassword: [{ validator: validateConfirm, trigger: 'blur' }]
  }

  const handleUpdatePassword = () => {
    passwordForm.password = ''
    passwordForm.confirmPassword = ''
    passwordDialogVisible.value = true
  }

  const submitPassword = () => {
    if (!passwordFormRef.value) return
    passwordFormRef.value.validate(async (valid) => {
      if (valid) {
        try {
          await updateUserPassword({ password: passwordForm.password })
          ElMessage.success('密码修改成功，请重新登录')
          passwordDialogVisible.value = false
          handleLogout()
        } catch (error) {
          console.error(error)
        }
      }
    })
  }

  const norm = (v) => (v == null ? '' : String(v).trim())
  const filterMenusByCode = (list, allowSet) => {
    // console.log(list,'allowSet',allowSet)
    const out = []
    list.forEach(it => {
      const childrenSrc = Array.isArray(it._child) ? it._child : []
      const children = filterMenusByCode(childrenSrc, allowSet)
      const match = allowSet.has(norm(it.code))
      const isShow = it && Object.prototype.hasOwnProperty.call(it, 'is_show')
        ? (String(it.is_show) === '1' || Number(it.is_show) === 1)
        : true
      
      if (match && isShow) {
        out.push({ ...it, _child: children })
      }
    })
    return out
  }
onMounted(() => {
  checkMobile()
  window.addEventListener('resize', checkMobile)

  const uiStr = localStorage.getItem('userInfo') || '{}'
  let ui = {}
  try { ui = JSON.parse(uiStr) } catch (e) { ui = {} }
  isAdmin.value = Number(ui && ui.is_admin) === 1 || String(ui && ui.is_admin) === '1'
  username.value = (ui && ui.username) || ''
  const perms = Array.isArray(ui && ui.permission) ? ui.permission : []
  const allowSet = new Set((perms || []).map(v => norm(v)))
    getMenuList({ limit: 10000, page: 1 }).then(res => {
      const list = res.list || res || []
      // menuTree.value = list
      menuTree.value = filterMenusByCode(list, allowSet)
    })
  })

  onUnmounted(() => {
    window.removeEventListener('resize', checkMobile)
  })

  const handleLogout = () => {
    setToken('')
    localStorage.removeItem('userInfo')
    localStorage.removeItem('permission')
    router.replace('/login')
  }

</script>

<style scoped>
.common-layout {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

.el-container {
  height: 100%;
}

.header {
  background-color: #fff;
  border-bottom: 1px solid #dcdfe6;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  height: 60px;
}

.logo {
  display: flex;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  color: #409eff;
}

.logo-img {
  width: 30px;
  height: 30px;
  margin-right: 10px;
}

.user-info {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.username {
  /* margin-left: 10px; */
  font-size: 14px;
  color: #606266;
}
.dropdown-trigger {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.main-container {
   overflow: hidden;
}

.aside {
  background-color: #fff;
  border-right: 1px solid #dcdfe6;
  /* overflow-y: auto; */
  height: 100%;
}

.el-menu-vertical {
  border-right: none;
  /* height: 100%; */
  /* overflow-y: auto; */
}
.el-menu-vertical:not(.el-menu--collapse) {
  width: 260px;
  min-height: 400px;
}
 
.main {
  background-color: #f0f2f5;
  padding: 20px;
  box-sizing: border-box;
  overflow-y: auto;
  flex: 1;
}

.footer {
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #909399;
  background-color: #f0f2f5;
}

.footer a {
  color: inherit;
  text-decoration: none;
}

.footer a:hover {
  color: #409eff;
}

 
.el-aside{
  width: auto !important;
}
.el-menu-item.is-active {
  background-color: #e6f7ff !important;
  color: #409eff !important;
  border-right: 4px solid #409eff !important;
}

/* 移动端适配样式 */
@media screen and (max-width: 768px) {
  .mobile-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }

  .aside.mobile-aside {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    z-index: 1001;
    transform: translateX(-100%);
    transition: transform 0.3s ease-in-out;
    width: 260px !important;
    box-shadow: 2px 0 8px rgba(0,0,0,0.15);
  }

  .aside.mobile-aside-open {
    transform: translateX(0);
  }

  .header {
    padding: 0 10px;
  }
  
  .main {
    padding: 10px;
  }
  
  .title {
    font-size: 16px;
  }
  
  .logo {
    padding: 0 10px;
    height: 60px;
  }
}
</style>
